import { Loader2 } from 'lucide-react';
import { createPortal } from 'react-dom';

interface LoadingStateProps {
  message?: string;
  isLoading?: boolean;
}

export function LoadingState({ message = 'Loading...', isLoading }: LoadingStateProps) {
  if (!isLoading) return null;

  return createPortal(
    <div className="flex items-center justify-center py-12 absolute inset-0 bg-black/50 z-50">
      <Loader2 className="w-12 h-12 text-white animate-spin" />
      <span className="ml-3 text-lg text-white font-bold">{message}</span>
    </div>,
    document.body
  );
}
